<template>
  <Card>
    <div class="card-block">
      <div class="table-action">
        <slot name="table-action"></slot>
      </div>
      <slot name="table-container">
        <div class="responsive-table-container">
          <slot name="table">
            <table class="table">
              <slot name="thead">
              </slot>
              <slot name="tbody">
              </slot>
            </table>
          </slot>
        </div>
      </slot>
    </div>
  </Card>
</template>

<script>
  export default {
    name: 'table-card',
  };
</script>



// WEBPACK FOOTER //
// src/components/TableCard.vue